export default __webpack_public_path__ + "static/media/reprovar.fc1c9e67.svg";